import React from 'react';
import {lovLabel, lovValue} from 'core/form/formUtils';
import {joinNonNull} from 'core/common/utils/arrayUtils';
import {grey300} from "material-ui/styles/colors";
import 'invoice/component/invoiceSumTable.less';
import {observer} from "mobx-react";
import {InvoiceTemplate} from "invoice/domain/invoiceDomain";
import MdEntity from "core/metamodel/mdEntity";
import {ObservableMap} from "mobx";


interface InvoiceTemplateSumTableProps {
  invoiceTemplateObject: InvoiceTemplate;
  invoiceTemplateEntity: MdEntity;
  entities: ObservableMap<MdEntity>;
  style: any;

}

@observer
export default class InvoiceTemplateSumTable extends React.Component<InvoiceTemplateSumTableProps, undefined> {


  render() {

    const {invoiceTemplateObject, entities, invoiceTemplateEntity, style} = this.props;


    let basePrice = invoiceTemplateEntity.getField('basePrice'),
      itemAdjustmentAmount = invoiceTemplateEntity.getField('itemAdjustmentAmount'),    // Sum (invoiceItem.adjustmentAmount)
      itemAdjustmentKoef = invoiceTemplateEntity.getField('itemAdjustmentKoef'),    // itemAdjustmentAmount / basePrice
      basePriceWithAdjustment = invoiceTemplateEntity.getField('basePriceWithAdjustment'),    // basePrice + itemAdjustmentAmount
      invoiceAdjustmentKoef = invoiceTemplateEntity.getField('invoiceAdjustmentKoef'),    // zadano
      invoiceAdjustmentAmount = invoiceTemplateEntity.getField('invoiceAdjustmentAmount'),    // (basePriceWithAdjustment * invoiceAdjustmentKoef)cr
      priceWithoutVat = invoiceTemplateEntity.getField('priceWithoutVat'),
      vatAmount = invoiceTemplateEntity.getField('vatAmount'),
      totalPrice = invoiceTemplateEntity.getField('totalPrice'),    // sum (invoiceItem.itemPrice)
      pennyAdjustment = invoiceTemplateEntity.getField('pennyAdjustment'),
      totalAdjustedPrice = invoiceTemplateEntity.getField('totalAdjustedPrice'),

      invoiceCurrencyLabel = lovLabel(invoiceTemplateObject.invoiceCurrency),
      invoiceCurrencyValue = lovValue(invoiceTemplateObject.invoiceCurrency)
      ;

    return (

      <table className="invoice-sum-table" style={style}>
        <thead>
        <tr>
          <th style={{backgroundColor: grey300}}/>
          {(invoiceTemplateObject.itemAdjustmentAmount || invoiceTemplateObject.invoiceAdjustmentAmount) ? <th>{basePrice.gridHeaderLabelActive}</th> : null}
          {(invoiceTemplateObject.itemAdjustmentAmount) ? <th>{itemAdjustmentAmount.gridHeaderLabelActive}</th> : null}
          {(invoiceTemplateObject.invoiceAdjustmentAmount) ? <th>{invoiceAdjustmentAmount.gridHeaderLabelActive}</th> : null}
          <th>{priceWithoutVat.gridHeaderLabelActive}</th>
          <th>{vatAmount.gridHeaderLabelActive}</th>
          <th>{totalPrice.gridHeaderLabelActive}</th>
          {(invoiceTemplateObject.pennyAdjustment) ? <th>{pennyAdjustment.gridHeaderLabelActive}</th> : null}
          {(invoiceTemplateObject.pennyAdjustment) ? <th>{totalAdjustedPrice.gridHeaderLabelActive}</th> : null}
        </tr>
        </thead>
        <tbody>
          <tr>
            <td>{invoiceCurrencyLabel}</td>
            {(invoiceTemplateObject.itemAdjustmentAmount || invoiceTemplateObject.invoiceAdjustmentAmount) ? <td>{basePrice.formatValue(invoiceTemplateObject.basePrice)}</td> : null}
            {(invoiceTemplateObject.itemAdjustmentAmount) ? <td> <div>{itemAdjustmentAmount.formatValue(invoiceTemplateObject.itemAdjustmentAmount)}</div><div style={{fontSize: 10}}>{itemAdjustmentKoef.formatValue(invoiceTemplateObject.itemAdjustmentKoef)}</div>  </td> : null}
            {(invoiceTemplateObject.invoiceAdjustmentAmount) ? <td>{invoiceAdjustmentAmount.formatValue(invoiceTemplateObject.invoiceAdjustmentAmount)}</td> : null}
            <td>{priceWithoutVat.formatValue(invoiceTemplateObject.priceWithoutVat)}</td>
            <td>{vatAmount.formatValue(invoiceTemplateObject.vatAmount)}</td>
            <td className="invoice-sum-table--big">{ joinNonNull([totalPrice.formatValue(invoiceTemplateObject.totalPrice), invoiceCurrencyLabel], ' ')}</td>
            {(invoiceTemplateObject.pennyAdjustment) ? <td>{pennyAdjustment.formatValue(invoiceTemplateObject.pennyAdjustment)}</td> : null}
            {(invoiceTemplateObject.pennyAdjustment) ? <td className="invoice-sum-table--big">{totalAdjustedPrice.formatValue(invoiceTemplateObject.totalAdjustedPrice) + ' ' + invoiceCurrencyLabel}</td> : null}
          </tr>

        </tbody>
      </table>

    );
  }
}




// WEBPACK FOOTER //
// ./src/invoice/component/invoiceTemplateSumTable.tsx